const coreText = {
    fontFamily: {
        sfPro: 'SF Pro',
        segoeUI: 'Segoe UI',
        roboto: 'Roboto',
        ubuntu: 'Ubuntu',
        sfMono: 'SF Mono',
        consolas: 'Consolas',
        robotoMono: 'Roboto Mono',
        ubuntuMono: 'Ubuntu Mono',
    },
    fontWeight: {
        display1: '700',
        display2: '600',
        display3: '600',
        bodyLargeBold: '600',
        bodyLargeMedium: '500',
        bodyLarge: '400',
        bodyBold: '600',
        body: '400',
        subtitleBold: '600',
        subtitle: '400',
        caption: '400',
        label: '600',
    },
    fontSize: {
        display1: '36px',
        display2: '24px',
        display3: '20px',
        bodyLargeBold: '16px',
        bodyLargeMedium: '16px',
        bodyLarge: '16px',
        bodyBold: '14px',
        body: '14px',
        subtitleBold: '12px',
        subtitle: '12px',
        caption: '10px',
        label: '10px',
    },
    lineHeight: {
        display1: '40px',
        display2: '28px',
        display3: '24px',
        bodyLargeBold: '20px',
        bodyLargeMedium: '20px',
        bodyLarge: '20px',
        bodyBold: '20px',
        body: '20px',
        subtitleBold: '16px',
        subtitle: '16px',
        caption: '12px',
        label: '12px',
    },
    textCase: {
        none: 'none',
        upper: 'uppercase',
        lower: 'lowercase',
        cap: 'capitalize',
    },
    textDecoration: {
        none: 'none',
        underline: 'underline',
        lineThrough: 'line-through',
    },
};
export default coreText;
